module.exports = "<div id=\"youtube-player{{ videoId }}\"></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-players/nn-player-youtube/nn-player-youtube.directive.html
// module id = 1045
// module chunks = 0